import "./slider/slider.js";
import "./posts/loadmore";
import "./zustand.js";
import "../sass/main.scss";

const navBtn = document.querySelector(".btn-nav");
const navHandler = document.querySelector(".nav-handler");

navBtn.addEventListener("click", (evt) => {
  const navBtnEvent = evt.currentTarget;
  if (navBtnEvent.getAttribute("data-state") === "active") {
    navBtnEvent.setAttribute("data-state", "");
    navHandler.setAttribute("data-state", "");
    return;
  }
  navBtnEvent.setAttribute("data-state", "active");
  navHandler.setAttribute("data-state", "active");
});
